import styled from 'styled-components';

const Link = styled.a`
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
`;

export default Link;
